import type { ReactNode } from "react";
import { AlertCircle, Info, X } from "lucide-react";
import { ActionIcon } from "./ActionIcon";

type ToastProps = {
  action?: ReactNode;
  children: ReactNode;
  icon?: ReactNode;
  onDismiss?: () => void;
  title: string;
  tone?: "default" | "danger";
};

export function Toast({
  action,
  children,
  icon,
  onDismiss,
  title,
  tone = "default",
}: ToastProps) {
  const Icon = tone === "danger" ? AlertCircle : Info;

  return (
    <div
      aria-atomic="true"
      className={`ui-toast ui-toast--${tone}`}
      role={tone === "danger" ? "alert" : "status"}
    >
      <span className="ui-toast-icon">
        {icon ?? <Icon aria-hidden="true" />}
      </span>
      <div className="ui-toast-content">
        <strong>{title}</strong>
        <p>{children}</p>
      </div>
      {onDismiss && (
        <ActionIcon
          icon={<X />}
          label="Dismiss notification"
          onClick={onDismiss}
          size="small"
        />
      )}
      {action && <div className="ui-toast-action">{action}</div>}
    </div>
  );
}
